<template>
  <main class="Page-styles-page">
    <div class="BetslipDelivered-styles-bet-preview-page" testid="BetId-34471458311">
      <h1 class="">
        <div class="BetslipDelivered-styles-img-success"></div>
        <div class="BetslipDelivered-styles-title">
          {{ t.bet_was_accepted || 'Your bet slip was accepted. Good luck!'}}
        </div>
      </h1>
      <div class="Paper-styles-paper Card-styles-paper BetslipDelivered-styles-card-container" v-if="b">
        <div class="Card-styles-card">
          <router-link :to="{name: 'my_bets'}" class="BetslipDelivered-styles-card-item BetslipDelivered-styles-space-between" id="betslip-success-systemtype">
            <div class="BetslipDelivered-styles-card-link">
              <div class="BetslipDelivered-styles-card-item BetslipDelivered-styles-bold BetslipDelivered-styles-title-system-type BetslipDelivered-styles-card-arrow"><span>{{ b.type.name }}</span><span class="BetslipDelivered-styles-arrow-container"><img src="/static/assets/img/arrow-right-grey.svg"></span></div>
              <div id="betslip-success-preview-wager" class="BetslipDelivered-styles-card-item BetslipDelivered-styles-space-between"><span>{{ t.betting.title.amount_per_bet }}</span><span>{{ b.odd_count }} x {{ b.amount_per_bet | toMoney(session.currency) }}</span></div>
              <div id="betslip-success-preview-total-price" class="BetslipDelivered-styles-card-item BetslipDelivered-styles-space-between"><span>{{ t.betting.title.payed }}</span><span id="total-price">{{ b.amount | toMoney(session.currency) }}</span></div>
              <div id="betslip-success-preview-possible-winnings" class="BetslipDelivered-styles-card-item BetslipDelivered-styles-space-between"><span>{{ t.betting.title.earnings }}</span><span class="BetslipDelivered-styles-green BetslipDelivered-styles-bold">{{ b.earnings | toMoney(session.currency)  }}</span></div>
            </div>
          </router-link>
          <div class="BetslipDelivered-styles-card-button-container">
            <div @click="reuseBet(b.id)" id="reuseBetslip" class="BetslipDelivered-styles-card-button">
              <img class="BetslipDelivered-styles-card-item-icon" src="/static/assets/img/reuse.svg">
              <span>{{ t.reuse_bet }}</span>
            </div>
            <a target="_blank" :href="bsapi+'api/v1/bet/detail/'+b.id+'?tz='+session.timezone+'&print=1'" id="reuseBetslip" class="BetslipDelivered-styles-card-button">
              <img class="BetslipDelivered-styles-card-item-icon" src="/static/assets/img/print.svg">
              <span>{{ t.print }}</span>
            </a>
            <hr>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import betSlip from '@/mixins/betSlip'
export default {
  name: "BetSlipSucces",
  mixins: [betSlip],
  data(){
    return {
      bsapi: window.bsapi,
      session: session,
      t: this.$root.t,
      b: null
    }
  },
  mounted() {
    this.fetchLastBet()
  },
  methods: {
    fetchLastBet(){
      this.$http.get(api+'api/v1/bets', {
        params: {page: 1, per_page: 1, t: Math.round(new Date().getTime()/1000)}}
      ).then(response => {

        response.body.result.bets.forEach((v) => {
          this.b = v;
        })

      })
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/sportsbook/BetSlipSuccess.vue